import { useMemo } from 'react';
import { getAdditionalTableHeaders } from '../components/tableSettings/OverviewTableSettings';
import { getGrowthTableSettings } from '../components/tableSettings/GrowthTableSettings';
import { getContactInfoTableSettings } from '../components/tableSettings/ContactInfoTableSettings';
import { getListingProficiencyTableSettings } from '../components/tableSettings/ListingProficiencyTableSettings'
import { getActivityTableSettings } from '../components/tableSettings/ActivityTableSettings';

export const useOverviewAdditionalHeaders = (columns, rowData, dateRangesText, col1TitlePrefix, tooltips ) =>
    useMemo(() =>  getAdditionalTableHeaders(
        columns,
        rowData,
        dateRangesText,
        col1TitlePrefix,
        tooltips,
    ), [columns, rowData, dateRangesText]);

export const useContactInfoAdditionalHeaders = (columns, dateRangesText, tooltips) =>
    useMemo(() => getContactInfoTableSettings(columns, dateRangesText, tooltips),[columns, dateRangesText]);


export const useGrowthAnalysisAdditionalHeaders = (columns) =>
    useMemo(() => getGrowthTableSettings(columns), [columns]);


export const useListingProfAdditionalHeaders = (columns, tooltips) =>
    useMemo(() => getListingProficiencyTableSettings({ columns, tooltips }), [columns]);

export const useActivityAdditionalHeaders = (columns, dateRangesText, activityCount) =>
    useMemo(() => getActivityTableSettings(columns, dateRangesText, activityCount),[columns, dateRangesText, activityCount]);
